import React, { useRef, useEffect } from "react";
import clsx from "clsx";
import classes from "./TextArea.module.css";

const TextArea = ({
  value,
  setValue,
  placeholder,
  className,
  name,
  rows,
  onKeyDown,
  resetHeight,
}) => {
  const textareaRef = useRef(null);

  // Adjust height based on content
  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "55px"; // Reset height to auto
      textareaRef.current.style.height = `${Math.min(
        textareaRef.current.scrollHeight,
        220
      )}px`; // Max height 220px
    }
  };

  // Reset height when resetHeight prop changes
  useEffect(() => {
    if (resetHeight && textareaRef.current) {
      textareaRef.current.style.height = "55px"; // Reset height
      setValue(""); // Optionally clear the value
    }
  }, [resetHeight, setValue]);

  // Adjust height when value changes
  useEffect(() => {
    adjustHeight();
  }, [value]);

  useEffect(() => {
    // Adjust height on initial render as well
    adjustHeight();
  }, []); // Empty dependency array ensures this runs only once after the first render

  return (
    <textarea
      ref={textareaRef}
      name={name}
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
        adjustHeight(); // Adjust height on user input
      }}
      className={clsx(classes.textArea, className, "overflow")}
      placeholder={placeholder}
      required={true}
      rows={rows}
      onKeyDown={onKeyDown}
    />
  );
};

export default TextArea;
